export const AnnouncementScope = Object.freeze({
  Global: "Global",
  ProductVariant: "ProductVariant",
});

export const AnnouncementRouteScope = Object.freeze({
  Global: "global",
  Course: "course",
});
